import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CountryWiseServiceRequirementRoutingModule } from './country-wise-service-requirement-routing.module';
import { CountryWiseServiceRequirementListComponent } from './country-wise-service-requirement-list/country-wise-service-requirement-list.component';
import { CountryWiseServiceRequirementFormComponent } from './country-wise-service-requirement-form/country-wise-service-requirement-form.component';

@NgModule({
  declarations: [
    CountryWiseServiceRequirementListComponent,
    CountryWiseServiceRequirementFormComponent
  ],
  imports: [
    CommonModule,
    CountryWiseServiceRequirementRoutingModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class CountryWiseServiceRequirementModule { }
